module.exports = __webpack_public_path__ + "img/form_bg.802ff58e.jpg";